import React from 'react'
import propTypes from 'prop-types'
import VimeoEmbed from '@/component/Primitive/VimeoEmbed'

export const VimeoPlayer = ({ link }) => {
  const getVimeoId = (link) => link && link.split('/').slice(-1)
  return <VimeoEmbed videoId={getVimeoId(link)} />
}

VimeoPlayer.propTypes = {
  link: propTypes.string
}
